import Immutable from 'immutable';
import { SET_PARENTAL_LOCK } from '../actions/parentalLock';
import { SET_AUTOPLAY } from '../actions/autoplay';

const SETTINGS = 'settings';
const PARENTAL_LOCK = ['parentalLock'];
const AUTOPLAY = ['autoplay'];

const initialState = Immutable.fromJS({
    parentalLock: null,
    autoplay: true,
});

export default function settings(state = initialState, action) {
    switch (action.type) {
        case SET_PARENTAL_LOCK:
            return state.setIn([PARENTAL_LOCK], action.payload);
        case SET_AUTOPLAY:
            return state.setIn([AUTOPLAY], action.payload);
        default:
            return state;
    }
}

export const parentalLockSelector = (state) => state.getIn([SETTINGS, PARENTAL_LOCK]);
export const autoPlaySelector = (state) => state.getIn([SETTINGS, AUTOPLAY], true);
